import { render, staticRenderFns } from "./deptInternshipSum.vue?vue&type=template&id=a613330e&scoped=true"
import script from "./deptInternshipSum.vue?vue&type=script&lang=js"
export * from "./deptInternshipSum.vue?vue&type=script&lang=js"
import style0 from "./deptInternshipSum.vue?vue&type=style&index=0&id=a613330e&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a613330e",
  null
  
)

export default component.exports